import script from "./LoadingMask.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingMask.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingMask.vue?vue&type=style&index=0&id=24bb5376&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24bb5376"]])

export default __exports__